import * as types from '@/store/mutation-types';

const subscribers = store => store.subscribe((mutation) => {
  switch (mutation.type) {
    case types.FETCH_USER_SUCCESS:
      store.dispatch('fetchGridOptions');
      break;
    default:
      break;
  }
});

export default subscribers;
